import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/Index'
import Challenger from '../pages/Challenger'
import ThankYou from '../pages/ThankYou'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/vyzyvatel/:alias',
      name: 'Challenger',
      component: Challenger
    },
    {
      path: '/thank-you',
      name: 'ThankYou',
      component: ThankYou
    },
    {
      path: '*',
      redirect: '/'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js